module.exports = __webpack_public_path__ + "img/_weapon_ring_11.1e1170f3.png";